import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Navbar, Nav, Container, Dropdown, Image } from "react-bootstrap";
import { FaUser, FaSignOutAlt, FaBell, FaCog } from "react-icons/fa";

const AppNavbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  const handlesetting = () => {
    navigate("/settings/subscription-types");
  };
  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="app-navbar">
      <Container fluid>
        {/* <Navbar.Brand href="/dashboard" className="fw-bold">
          <span className="text-warning">V</span>Shape Gym Management
        </Navbar.Brand> */}
        <Navbar.Brand
          href="/dashboard"
          className="d-flex align-items-center gap-3"
        >
          {/* Logo Image */}
          <Image
            src="/assets/logo.png"
            alt="VShape Gym Management Logo"
            height="50"
            className="d-inline-block align-top"
          />
          <span className="d-none d-md-inline fw-bold text-white">
            VShape Gym Management
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="align-items-center">
            <Nav.Link href="#" className="text-white me-3">
              <FaBell size={18} />
            </Nav.Link>

            <Dropdown align="end">
              <Dropdown.Toggle
                variant="dark"
                id="dropdown-user"
                className="d-flex align-items-center"
              >
                <div className="user-avatar me-2">
                  <FaUser />
                </div>

                <div className="user-info d-none d-md-block">
                  <div className="fw-bold text-white">{user?.username}</div>
                  <small className="text-white">{user?.email}</small>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#">
                  <FaUser className="me-2" />
                  Profile
                </Dropdown.Item>

                <Dropdown.Item href="#" onClick={handlesetting}>
                  <FaCog className="me-2" />
                  Settings
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item onClick={handleLogout}>
                  <FaSignOutAlt className="me-2" />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
